import { render, staticRenderFns } from "./UploadProfileButtonGroup.vue?vue&type=template&id=b471f12e&scoped=true&"
import script from "./UploadProfileButtonGroup.vue?vue&type=script&lang=js&"
export * from "./UploadProfileButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b471f12e",
  null
  
)

export default component.exports